import React, { lazy, Suspense } from 'react';
const Dashboard = lazy(() => import('./Dashboard'));

const SuspenseDashboard = ({ layout, ...others }) => {
  const { dashboard: Layout } = layout;
  return (
    <Layout>
      <Suspense fallback={<div>Loading...</div>}>
        <Dashboard />
      </Suspense>
    </Layout>
  );
};

const routes = ({ requireAuth, pluginHelper }) => [
  {
    exact: true,
    path: '/dashboard/admin/googletrends',
    component: requireAuth(pluginHelper(SuspenseDashboard), 'admin'),
  },
];

const dashboardAdminMenu = (user, feature) =>
  [
    feature('googletrends') && {
      icon: 'google',
      content: 'Google Trends',
      name: 'googletrends',
      to: '/dashboard/admin/googletrends',
    },
  ].filter(Boolean);

export default {
  routes,
  dashboardAdminMenu,
};
